// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SegmentForm_delete_1cePD{display:flex;color:#f5abab;align-items:center}.SegmentForm_delete_1cePD .SegmentForm_icon_2_aWD{margin-right:8px}.SegmentForm_delete_1cePD .SegmentForm_icon_2_aWD path{fill:#cbced1;transition:fill .2s ease-in}.SegmentForm_delete_1cePD:hover .SegmentForm_icon_2_aWD path{fill:#8391a2}", ""]);
// Exports
exports.locals = {
	"delete": "SegmentForm_delete_1cePD",
	"icon": "SegmentForm_icon_2_aWD"
};
module.exports = exports;
